module.exports = __webpack_public_path__ + "img/welfare-storevip.81f4a642.png";